import { supabase } from 'src/services/supabase-client';
import { Note } from '../types/note';

export async function editNote(note: Note): Promise<void> {
  await supabase.from<Note>('notes').update(note).eq('id', note.id);
}
